import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Navbar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getSystemVersion } from "../slices/systemSlice";
import "../pages/Common.css";
import bwLogo from "../pages/images/bw.png";
import bwcloudLogo from "../pages/images/bwcloud.png";
import nfdiLogo from "../pages/images/nfdi.png";

const formatUTC = (d) =>
  d && !isNaN(new Date(d))
    ? new Date(d).toISOString().replace("T", " ").substring(0, 19) + " UTC"
    : "N/A";

const Footer = () => {
  const dispatch = useDispatch();
  const { backendVersionData: backendVD } = useSelector(
    (state) => state.system || {},
  );
  const frontUrl = process.env.REACT_APP_SOURCE_URL || "";

  useEffect(() => {
    dispatch(getSystemVersion());
  }, [dispatch]);

  const backendCommitUrl =
    backendVD?.gitRepositoryUrl && backendVD?.gitCommitHash
      ? `${backendVD.gitRepositoryUrl.replace(/\/$/, "")}/-/commits/${backendVD.gitCommitHash}`
      : "#";

  return (
    <Navbar className="homepage-footer">
      {/* LEFT SIDE: Code version information */}
      <div className="footer-left-info">
        <div className="version-info-line">
          <strong>Backend code:</strong>{" "}
          {backendVD?.gitRepositoryUrl && backendVD?.gitCommitHash ? (
            <a
              href={backendCommitUrl}
              target="_blank"
              rel="noreferrer"
              className="footer-link"
              title={`Build date: ${formatUTC(backendVD?.buildDate)}`}
            >
              {backendVD.gitCommitHash.substring(0, 7)}
            </a>
          ) : (
            <span title={`Build date: ${formatUTC(backendVD?.buildDate)}`}>
              {backendVD?.gitCommitHash?.substring(0, 7) || "N/A"}
            </span>
          )}
          , <strong>Frontend code:</strong>{" "}
          {frontUrl ? (
            <a
              href={frontUrl}
              target="_blank"
              rel="noreferrer"
              className="footer-link"
              title={`Build date: ${formatUTC(process.env.REACT_APP_BUILD_DATE)}`}
            >
              {frontUrl.split("/").pop().substring(0, 7)}
            </a>
          ) : (
            "N/A"
          )}
        </div>
      </div>

      {/* RIGHT SIDE: Logos */}
      <div className="footer-right-logos">
        <img src={bwLogo} width={100} style={{ padding: 10 }} alt="bw Logo" />
        <img
          src={bwcloudLogo}
          width={100}
          style={{ padding: 10 }}
          alt="bwCloud Logo"
        />
        <img
          src={nfdiLogo}
          width={180}
          style={{ padding: 10 }}
          alt="nfdi Logo"
        />
      </div>
    </Navbar>
  );
};

export default Footer;
